import * as React from 'react';
import { SelectInput, useTranslate } from 'react-admin';

const toChoices = (items, translate) =>
    items.map(item => ({
        id: item,
        name: translate(`resources.factures_boxroad.status.${item}`),
    }));
const AvisStatutInput = props => {
    const translate = useTranslate();
    const statuts = ['paid', 'not_paid'];
    return (
        <SelectInput
            choices={toChoices(statuts, translate)}
            {...props}
            emptyText="Tout"
        />
    );
};

export default AvisStatutInput;
